import {
  Address,
  GeoCoordinate,
  LocalOfferLocation,
  LocalOfferMarker,
  LocationTypeEnum,
  PartnerOfferDetails,
  RouteNavigationAction,
} from '@varo/graphql-schema-types';

/**
 * Build a LocalOfferLocation from PartnerOfferDetails.mapData and offer metadata.
 * Returns null when mapData is missing.
 */
export function buildLocalOfferLocation(
  offer: PartnerOfferDetails,
): LocalOfferLocation | null {
  const marker = offer.mapData?.markerLocation;
  const lat = marker?.latitude;
  const lng = marker?.longitude;

  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return null;
  }

  if (!offer.mapData) {
    return null;
  }

  const address: Address = {
    __typename: 'Address',
    addressLine1: offer.address?.addressLine1 ?? null,
    addressLine2: offer.address?.addressLine2 ?? null,
    city: offer.address?.city ?? null,
    state: offer.address?.state ?? null,
    zip: offer.address?.zip ?? null,
    country: offer.address?.country ?? null,
    externalId: offer.address?.externalId ?? null,
  };

  const coordinate: GeoCoordinate = {
    __typename: 'GeoCoordinate',
    latitude: offer.mapData.markerLocation.latitude,
    longitude: offer.mapData.markerLocation.longitude,
  };

  const location: LocalOfferLocation = {
    __typename: 'LocalOfferLocation',
    id: `${offer.id}`,
    type: LocationTypeEnum.LocalOffer,
    name: offer.name,
    address,
    addressCopy: offer.address?.addressLine1 ?? undefined,
    coordinate,
    distance: '',
    marker: LocalOfferMarker.Merchant,
    sourceMerchantId: offer.sourceMerchantId ?? undefined,
    cashbackAmount: offer.cashbackAmount ?? undefined,
    industry: offer.industry,
    logoImage: offer.logoImage,
    offerId: offer.id,
    offerType: offer.offerType,
    merchantId: offer.merchantId ?? undefined,
    offerSource: offer.offerSource,
    onClick: {
      __typename: 'RouteNavigationAction',
      route: `/rewards/${offer.id}`,
    } as RouteNavigationAction,
  };

  return location;
}
